import React from 'react';
import { ButtonGroup } from 'semantic-ui-react';
import CreateButton from '@/components/buttons/CreateButton';
import { states } from '@/constants/lifecycle';
import IconButton from '@/components/buttons/IconButton';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const FolderControls = ({ category, code }) => {
  const { readStatus, readErrors, canManage } = Selectors.useDatasetAttachmentsTableHeader({ category, code });
  const onShowCreateDatasetFolder = Events.useShowCreateDatasetFolder(category, { code });
  const onRefreshAttachments = Events.useFetchDatasetAttachments(category, { code });

  return (
    <ButtonGroup className="mr-5">
      {canManage && (
        <CreateButton
          disabled={readErrors.length > 0}
          entity="dataset.folder"
          onClick={onShowCreateDatasetFolder}
        />
      )}
      <IconButton
        className="aridhia-create-button"
        disabled={readStatus === states.PENDING}
        icon
        iconName="refresh"
        iconOnly
        iconClassName="primary"
        messageId="actions.refresh.attachments"
        onClick={onRefreshAttachments}
      />
    </ButtonGroup>
  );
};

export default FolderControls;
